import variables from '../../variables';
import {$data} from '../../helpers/data';
import is from 'is_js';
import {$dom} from '../../helpers/dom';
import {EffectCoverflow, EffectFade, Lazy, Navigation, Swiper, Pagination, Scrollbar} from 'swiper';
import {loop} from '../../helpers/_utilities';

Swiper.use([Navigation, EffectFade, Lazy, EffectCoverflow, Pagination, Scrollbar]);

const {merge, deepAssign} = $data;
const {
	get: domGet,
	addClass
} = $dom;

export default class CarouselController {
  constructor() {

    this.defaults = {
      slidesPerView: 1,
      spaceBetween: 30,
      slideActiveClass: variables.classNames.active,
      speed: variables.carouselDefaultDuration,
      navigation: {
        disabledClass: variables.classNames.disabled
      }
    };


    this.carousels = [];

  }

  create(carousels) {

    if(is.array(carousels)) {

	    let createdCarousels = carousels.map(carousel => {
        let opts = {}, carousels = [];

        const {apiOptions, customOptions, target} = carousel;

        if (apiOptions && is.object(apiOptions)) {
          opts = merge(
	          this.defaults,
            apiOptions
          );
        }

        $dom.callAll(target, t => {

	        if (customOptions && is.object(customOptions)) {

		        const modifiedCustomOptions = {};

		        const {navHolder} = customOptions;

		        if (navHolder && is.string(navHolder)) {
			        const nh = $dom.get(navHolder, t);

			        modifiedCustomOptions['navigation'] = {
				        prevEl: $dom.get('.is-control--prev', nh),
				        nextEl: $dom.get('.is-control--next', nh)
			        }
		        }

		        opts = deepAssign(
			        opts,
			        modifiedCustomOptions
		        );
	        }

	        carousels.push(new Swiper(t, opts))

        });

		    return carousels
      });

	    loop(createdCarousels, c => {
	    	if (is.array(c)) this.carousels = [...this.carousels, ...c]
	    });

		
    }

    return this.carousels;
  }

  destroy() {
    return this.carousels.filter(carousel => {
      carousel.destroy();
      return false;
    })
  }
}
